export const F_READONLY = 'R';
export const F_ABSTRACT = 'A';
export const F_PUBLIC = '$';
export const F_PRIVATE = '#';
export const F_PROTECTED = '@';
export const F_PROPERTY = 'P';
export const F_METHOD = 'M';
export const F_STATIC = 'S';
export const F_CLASS = 'C';
export const F_INTERFACE = 'I';
export const F_FUNCTION = 'F';
export const F_ARROW_FUNCTION = '>';
export const F_OPTIONAL = '?';
export const F_REST = '3';
export const F_ASYNC = 'a';
export const F_EXPORTED = 'e';
export const F_INFERRED = '.';
export const F_OMITTED = ',';
/**
 * Flag attached to parameters which indicates that the parameter
 * is actually an array binding expression (aka destructured assignment).
 */
export const F_ARRAY_BINDING = '[';
/**
 * Flag attached to parameters which indicates that the parameter
 * is actually an object binding expression (aka destructured assignment).
 */
export const F_OBJECT_BINDING = 'O';
export const T_UNION = '|';
export const T_INTERSECTION = '&';
export const T_ANY = '~';
export const T_UNKNOWN = 'U';
export const T_VOID = 'V';
export const T_UNDEFINED = 'u';
export const T_NULL = 'n';
export const T_TUPLE = 'T';
export const T_ARRAY = '[';
export const T_THIS = 't';
export const T_GENERIC = 'g';
export const T_MAPPED = 'm';
export const T_TRUE = '1';
export const T_FALSE = '0';
export const T_CALLSITE = 'c';
export const T_STAND_IN = '5';
export const T_OBJECT = 'O';
export const T_ENUM = 'e';
export const T_FUNCTION = 'F';
export const T_INTRINSICS = [T_VOID, T_ANY, T_UNKNOWN, T_UNDEFINED, T_TRUE, T_FALSE, T_THIS, T_NULL];
export const TI_VOID = { TΦ: T_VOID };
export const TI_ANY = { TΦ: T_ANY };
export const TI_UNKNOWN = { TΦ: T_UNKNOWN };
export const TI_UNDEFINED = { TΦ: T_UNDEFINED };
export const TI_TRUE = { TΦ: T_TRUE };
export const TI_FALSE = { TΦ: T_FALSE };
export const TI_THIS = { TΦ: T_THIS };
export const TI_NULL = { TΦ: T_NULL };
export function isLiteralNode(node) {
    return !!node['$__isTSNode'];
}
//# sourceMappingURL=format.js.map